import { getAuthAxiosBackend } from "../helpers/axios"

class StstisticServices{

    constructor(){
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('statistics', {params: data})
    }
}

export default new StstisticServices()